import MDBox from "components/MDBox";

// has number
// const hasNumber = (number) => new RegExp(/[0-9]/).test(number);
function hasNumber(str){
  var numb =str.match(/\d/g);
  numb = numb.join("");
  if(numb.length>=2){
    return true
  }
  return false
}
// has mix of small and capitals
function isUpper(str) {
  return /[A-Z]/.test(str);
}
function isLower(str) {
  return /[a-z]/.test(str);
}
// has special chars
const hasSpecial = (number) => new RegExp(/[!#@$%^&*)(+=._-]/).test(number);

// set color based on password strength
export const strengthColor = (count) => {
  if (count < 2) return { label: "خیلی ضعیف", color: "red" };
  if (count < 3) return { label: "ضعیف", color: "yelllow" };
  if (count < 4) return { label: "معمولی", color: "orange" };
  if (count < 5) return { label: "خوب", color: "green" };
  if (count < 6) return { label: "قوی", color: "green" };
  return { label: "ضعیف", color: "red" };
};

// password strength indicator
export const strengthIndicator = (number) => {
  let result = {};
  if (number.length > 8) {
    result.correctLength = true;
  } else if (number.length > 8) {
    result.correctLength = false;
  }

  if (hasNumber(number)) {
    result.hasNumber = true;
  } else if (!hasNumber(number)) {
    result.hasNumber = false;
  }
  if (hasSpecial(number)) {
    result.hasSpecial = true;
  } else if (!hasSpecial(number)) {
    result.hasSpecial = false;
  }
  if (isLower(number)) {
    result.hasSmall = true;
  } else if (!isLower(number)) {
    result.hasSmall = false;
  }
  if (isUpper(number)) {
    result.hasCaital = true;
  } else if (!isUpper(number)) {
    result.hasCaital = false;
  }

  return result;
};
